module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-product-face.a70fb48a.png";